<app-trial-logs-table></app-trial-logs-table>